<template>
    <v-menu
        v-model="menu"
        transition="scroll-y-transition"
        class="d-flex"
    >
        <template v-slot:activator="{ props }">
            <v-btn
                icon
                v-bind="props"
            >
                <v-icon>mdi-account</v-icon>
            </v-btn>
        </template>

        <v-list>
            <v-list-item>
                <v-row align="center">
                    <v-col cols="auto">
                        <v-icon>mdi-account</v-icon>
                    </v-col>
                    <v-col align="right">
                        <v-list-item-title>{{ auth.user?.username }}</v-list-item-title>
                    </v-col>
                </v-row>
            </v-list-item>

            <v-divider></v-divider>

            <!-- <v-list-item @click="goToSettings">
                <v-row align="center">
                    <v-col cols="auto">
                        <v-icon>mdi-cog</v-icon>
                    </v-col>
                    <v-col>
                        <v-list-item-title>Settings</v-list-item-title>
                    </v-col>
                </v-row>
            </v-list-item> -->

            <v-list-item @click="auth.signOut">
                <v-row align="center">
                    <v-col cols="auto">
                        <v-icon>mdi-logout</v-icon>
                    </v-col>
                    <v-col>
                        <v-list-item-title>Logout</v-list-item-title>
                    </v-col> </v-row>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script setup lang="ts">

import { useAuthenticator } from '@aws-amplify/ui-vue';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
const auth = useAuthenticator();

const menu = ref(false);
const router = useRouter();

const goToSettings = () => {
    router.push('/settings-view');
};

</script>